import { t as e } from "../utils-DiFe-_ei.js";
import { t } from "../dist-B6xjZgdF.js";
import * as n from "react";
import { jsx as r } from "react/jsx-runtime";
//#region src/foundations/alert/alert.tsx
var i = t("relative w-full rounded-lg border p-4 [&>svg~*]:pl-7 [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground", {
	variants: { variant: {
		default: "bg-background text-foreground",
		destructive: "border-destructive/50 text-destructive-text dark:border-destructive [&>svg]:text-destructive-text"
	} },
	defaultVariants: { variant: "default" }
}), a = n.forwardRef(({ className: t, variant: n, ...a }, o) => /* @__PURE__ */ r("div", {
	ref: o,
	role: "alert",
	className: e(i({ variant: n }), t),
	...a
}));
a.displayName = "Alert";
var o = n.forwardRef(({ className: t, ...n }, i) => /* @__PURE__ */ r("h5", {
	ref: i,
	className: e("mb-1 font-medium leading-none tracking-tight", t),
	...n
}));
o.displayName = "AlertTitle";
var s = n.forwardRef(({ className: t, ...n }, i) => /* @__PURE__ */ r("div", {
	ref: i,
	className: e("text-sm [&_p]:leading-relaxed", t),
	...n
}));
s.displayName = "AlertDescription";
//#endregion
export { a as Alert, s as AlertDescription, o as AlertTitle };

//# sourceMappingURL=alert.js.map